import React, {lazy, Suspense, forwardRef} from "react";
import BabylonAvatarPlayerProps, {BabylonAvatarPlayerRef} from "./BabylonAvatarPlayer.props";

const BabylonAvatarPlayer = lazy(() => import(/* webpackChunkName: "babylon" */"./BabylonAvatarPlayer"));


const BabylonAvatarPlayerLazy = forwardRef<BabylonAvatarPlayerRef, BabylonAvatarPlayerProps>(
    function BabylonAvatarPlayerLazy(props, ref) {
  return (
    <Suspense fallback={<div/>}>
      <BabylonAvatarPlayer
        ref={ref}
        {...props}
      />
    </Suspense>
  )
});

export default BabylonAvatarPlayerLazy;
